import { render } from "./UsuarioResumenEstadisticasFlota.vue?vue&type=template&id=f95c998c"
import script from "./UsuarioResumenEstadisticasFlota.vue?vue&type=script&lang=js"
export * from "./UsuarioResumenEstadisticasFlota.vue?vue&type=script&lang=js"

import "./UsuarioResumenEstadisticasFlota.vue?vue&type=style&index=0&id=f95c998c&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__